import { render } from "./TheLocaleSwitcher.vue?vue&type=template&id=3b5911fa&scoped=true"
import script from "./TheLocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./TheLocaleSwitcher.vue?vue&type=script&lang=js"

import "./TheLocaleSwitcher.vue?vue&type=style&index=0&id=3b5911fa&lang=scss&scoped=true"

import exportComponent from "/build/c65b55b7-e35c-4745-8ca4-2d2ba1e583e5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5911fa"]])

export default __exports__